import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

import { hasAnalyticsConsent, onConsentChanged } from './storage';

let initialized = false;

export function initLogRocketIfConsented(): void {
  const appId = import.meta.env.VITE_LOGROCKET_APP_ID;
  if (!appId || initialized || !hasAnalyticsConsent()) return;

  LogRocket.init(appId);
  setupLogRocketReact();
  initialized = true;
}

export function identifyLogRocketIfConsented(userId: string, traits: { email: string; name?: string }): void {
  if (!import.meta.env.VITE_LOGROCKET_APP_ID || !hasAnalyticsConsent()) return;

  initLogRocketIfConsented();
  if (initialized) {
    LogRocket.identify(userId, traits);
  }
}

export function bootstrapLogRocketConsentListener(): void {
  initLogRocketIfConsented();
  onConsentChanged(() => {
    initLogRocketIfConsented();
  });
}
